import React from 'react';
import styled from 'styled-components';
import { RollbackOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import OpenPageBase from 'Common/pages/OpenPageBase';

import SadFacePNG from 'assets/images/sad_face_icon.png';

const ImgWrapper = styled.div`
  display: inline-block;
  text-allign: center;
  & > img {
    width: 100%;
    height: 100%;
  }
`;

const Title = styled.h1`
  color: #822b66;
  font-weight: bold;
`;

const MainText = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
  & .light {
    font-weight: bold;
    color: #2d446c;
  }
`;

const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledA = styled.a`
  &:hover {
    text-decoration: underline;
  }
  font-size: 19px;
  color: ${(props) => props.theme.darkBlueGrayTwo};
`;

const ErrorPage: React.FC = () => (
  <OpenPageBase>
    <ContentWrapper>
      <Row justify="center">
        <Col>
          <ImgWrapper>
            <img src={SadFacePNG} alt="Sad face icon" />
          </ImgWrapper>
        </Col>

        <Col offset={1} span={9}>
          <Title>
            <FormattedMessage
              defaultMessage="Ops!"
              description="error page title"
            />
          </Title>

          <MainText>
            <FormattedMessage
              defaultMessage="Looks like there was an error on this page.<br></br> Click the link below and try again. If it still doesn't work, contact our support at <span>030/208 98 63 30</span> or by email: <span>support@inventorum.com</span>"
              values={{
                br: () => <br />,
                span: (txt: React.ReactNode[]) => (
                  <span className="light">{txt}</span>
                ),
              }}
            />
          </MainText>

          <StyledA href="/" style={{ fontSize: '19px' }}>
            <RollbackOutlined style={{ marginRight: '10px' }} />
            <FormattedMessage defaultMessage="Back to home page" />
          </StyledA>
        </Col>
      </Row>
    </ContentWrapper>
  </OpenPageBase>
);
export default ErrorPage;
